module.exports = __webpack_public_path__ + "img/icon-close-yellow.9cea0e22.svg";